<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">
          <div class="watermark">
            <img
              v-if="poReceive?.branch?.company?.watermark && invoiceHeader"
              :src="fileServerUrl + poReceive.branch.company.watermark"
              alt=""
              style="height: 400px!important"
            >
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="invoiceHeader">
                    <td colspan="100%">
                      <div style="display: flex; justify-content: flex-end; align-items: flex-start; padding-bottom: 10px; margin-bottom: 16px;">
                        <img
                          :src="`${getFileServerUrl}${poReceive?.branch?.company?.logo}`"
                          class="logo-img"
                          alt="Logo"
                          style="max-height: 80px;"
                        >
                      </div>
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td colspan="100%">
                      <div class="header-table" style="font-size: 12px; margin-top: 10px;">
                        <div style="display: flex; justify-content: center;">
                          <h1 style="font-size: 16px; text-decoration: underline;">PO Receive</h1>
                        </div>

                        <div style="display: flex; justify-content: space-between; margin-bottom: 4px">
                          <div>
                            <strong>Supplier,</strong><br>
                            <strong>{{ poReceive?.supplier?.name || poReceive?.supplier?.supplier_name }}</strong><br>
                            <p>{{ poReceive?.shipping_address }}</p>
                            <p v-if="poReceive?.purordermaster?.code">
                              <strong>PO Order:</strong> {{ poReceive.purordermaster.code }}
                            </p>
                          </div>

                          <div>
                            <p><strong>Receive No:</strong> {{ poReceive?.code }}</p>
                            <p><strong>Purchase Date:</strong> {{ formatDateView(poReceive?.purchase_date) }}</p>
                            <p><strong>Receive Date:</strong> {{ formatDateView(poReceive?.receive_date) }}</p>
                            <p><strong>Shipping Date:</strong> {{ formatDateView(poReceive?.shipping_date) }}</p>
                            <p><strong>Warehouse:</strong> {{ poReceive?.warehouse?.name }}</p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="display:flex; justify-content: start; margin-bottom: 4px; border:none; padding: 3px">
                              Item Details
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th>Sn</th>
                            <th>Code</th>
                            <th>Item</th>
                            <th>Lot No.</th>
                            <th>Unit</th>
                            <th>Qty.</th>
                            <th>Free Qty.</th>
                            <th>Sales Rate</th>
                            <th>Pur. Rate</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr v-for="(row, idx) in poReceive?.details || []" :key="row.id || idx">
                            <td style="border:1px solid #E0E0E0; text-align:center;">{{ idx + 1 }}</td>
                            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.product?.code }}</td>
                            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.product?.name }}</td>
                            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.lot_no }}</td>
                            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.product?.unit?.name }}</td>
                            <td style="border:1px solid #E0E0E0; text-align:end;">{{ row.qty }}</td>
                            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.free_qty }}</td>
                            <td style="border:1px solid #E0E0E0; text-align:end;">{{ formatNumber(row.sales_rate) }}</td>
                            <td style="border:1px solid #E0E0E0; text-align:end;">{{ formatNumber(row.rate) }}</td>
                            <td style="border:1px solid #E0E0E0; text-align:end;">{{ formatNumber(row.amount) }}</td>
                          </tr>

                          <tr>
                            <td colspan="8" style="border-top: none !important;"></td>
                            <td style="text-align:right;"><strong>TOTAL</strong></td>
                            <td style="text-align: right;">{{ formatNumber(poReceive?.amount) }}</td>
                          </tr>
                          <tr style="background-color: #f0f0f0;">
                            <td colspan="8" style="border-top: none !important;"></td>
                            <td style="font-weight: bold; text-align:right;"><strong>GRAND TOTAL</strong></td>
                            <td style="text-align: right; font-weight: bold;">{{ formatNumber(poReceive?.amount) }}</td>
                          </tr>
                          <tr>
                            <td colspan="100%" style="border: none;">
                              <div style="font-size: 12px; display: flex; margin-top: 20px;">
                                <p style="text-align: start;"><strong>Amount In words : </strong></p>
                                <p style="text-align: start; font-style: italic">
                                  <strong>{{ convertNumberToWords(poReceive?.amount || 0) }}</strong>
                                </p>
                              </div>
                              <div v-if="poReceive?.remarks" style="font-size: 12px; padding-top: 10px;">
                                <strong>Remarks:</strong>
                                <span v-html="poReceive.remarks"></span>
                              </div>
                            </td>
                          </tr>
                          <tr v-if="!poReceive?.details?.length">
                            <td colspan="10" style="text-align: center;">No product details found</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div style="margin-top: 10px;">
                        <v-row>
                          <v-col cols="4" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div class="signature-label">Prepared & Issued By</div>
                            </div>
                          </v-col>
                          <v-col cols="4" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div class="signature-label">Authorized Signatory</div>
                            </div>
                          </v-col>
                          <v-col cols="4" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div class="signature-label">Received & Accepted By</div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot v-if="invoiceHeader">
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <!-- <img v-if="orderInvoice?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${orderInvoice?.branch?.company?.footer_image}`" alt="" style="width: 100%; display: block;"> -->
              <div class="invoice-footer" v-if="invoiceHeader" style="margin-left:10px; margin-bottom:10px; color: #343591;">
                <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7" />
                  </svg>

                  <span>{{ poReceive?.branch?.company?.address }}</span>
                </p>

                <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z" />
                  </svg>

                  <strong>Phone: </strong>  +880 9610-993393, +880 2 222288648, www.remexingredient.com | www.remexcorp.com
                </p>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row justify="end" class="d-print-none mt-4">
      <v-col cols="12" justify="center" style="display:flex; justify-content: center;">
        <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
          Print without pad
        </v-btn>
        <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
          Print with pad
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import convertNumberToWords from "@/plugins/numberToWord";
import { formatDateView } from "@/plugins/helpers";

const route = useRoute();
const store = useStore();
const poReceive = ref();
const pagePadding = ref(0);
const invoiceHeader = ref(true);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl || "");
const fileServerUrl = getFileServerUrl;

const formatNumber = (value) => Number(value || 0).toLocaleString("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const print = (isPad) => {
  invoiceHeader.value = isPad === 1;
  pagePadding.value = isPad === 1 ? 0 : 100;

  setTimeout(() => {
    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>PO Receive</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @page { size: A4; margin: ${pagePadding.value}px 0; }
        html, body { margin: 0; padding: 0; width: 100%; height: auto; }
        body { font-family: sans-serif; background:#fff; color:#000; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        .header-table, .details-table { padding: 0 32px; }
        .report-paper, .invoice-container, .invoice-content { width: 100%; margin: 0; padding: 0 !important; background: #fff; overflow: visible; }
        table { width: 100% !important; border-collapse: collapse; font-size: 12px; margin: 8px 0; background: white; }
        th, td { border: none; padding: 0; vertical-align: middle; }
        th { background: #e0e0e0; text-align: center; font-weight: bold; }
        .watermark { position: fixed; transform: translate(143%, 170%); z-index: 0; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .v-row { display: flex !important; flex-wrap: wrap !important; margin: 0; width: 100%; padding: 0 30px; justify-content: space-between; }
        .v-col-4 { flex: 0 0 33.333333% !important; max-width: 33.333333% !important; padding: 0 12px; }
        .pa-6 { padding: 0 !important; }
        .invoice-footer { position: fixed; left: 0; bottom: 0; width: 100%; color: #343591; font-size: 13px; padding: 0 10px 10px; }
        .signature-label { text-transform: uppercase; font-weight: bold; font-size: 12px; }
        img { max-width: 100% !important; height: auto !important; }
        @media print { .d-print-none { display: none !important; } .report-paper { box-shadow: none !important; border: none !important; } }
      </style>
      </head>
      <body>${printContent}</body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500);
};

onMounted(() => {
  const id = route.params.id;
  if (!id) return;

  store.dispatch("getInvPoReceiveById", id).then((response) => {
    const receive = response?.data || response;
    const details = receive?.InvPoReceiveDetails ||
      receive?.inv_po_receive_details ||
      receive?.invPoReceiveDetails ||
      [];

    poReceive.value = {
      ...receive,
      purordermaster: receive?.purordermaster || receive?.pur_order_master || {},
      details
    };
  });
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.dep-table th, .dep-table td { border: 1px solid #E0E0E0; padding: 2px; font-size: 12px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark { position: absolute; transform: translate(50%, 50%); z-index: 0; }
.signature-label { text-transform: uppercase; font-weight: bold; font-size: 12px; }
.invoice-footer { margin-left: 10px; margin-bottom: 10px; color: #343591; }
@media print { .d-print-none { display: none !important; } }
</style>
